import firebase from '../../../lib/firebase.prod';
import * as PROJECT_CODE from '../../../constants/projectCode';
import dayjs from 'dayjs';
const firebaseRef = firebase.database();

export async function saveManualVerification(
	file,
	formData,
	dbInfo,
	isNameChanged,
	callback
) {
	try {
		const leadId = dbInfo?.leadId;
		const id = dbInfo?.id;
		const fileImg = file.raw;
		const timestamp = dayjs(new Date());
		// 1. image store, update DB
		let storage = await firebase
			.storage()
			.ref(
				PROJECT_CODE.projectCode +
					'/userIdentification/' +
					leadId +
					'/' +
					timestamp
			);

		await storage.put(fileImg);
		// 2. get image file url
		await storage.getDownloadURL().then((url) => {
			let identification = {
				report: {
					document: {
						first_name: formData.firstName,
						last_name: formData.lastName,
						type: formData.idType,
						dateOfBirth: formData.dateOfBirth,
						idNumber: formData.idNumber,
						// address: formData.address,
						imgUrl: url,
						address1: formData?.address1 || '',
						address2: formData?.address2 || '',
						city: formData?.city || '',
						province: formData?.province || '',
						postalCode: formData?.postalCode || '',
					},
				},
				verification: {
					date: dayjs().format('DD-MMM-YYYY'),
					status: 'manually_verified',
				},
			};
			// 3. stroe to /kavtek_agreemetns or /kavtek_leads

			if (dbInfo?.node === 'lead') {
				const leadRef = firebaseRef.ref(
					'/kavtek_leads/' + PROJECT_CODE.projectCode + `/${leadId}`
				);
				leadRef.update({
					identification,
				});
				if (isNameChanged) {
					leadRef.update({
						clientFName: formData?.firstName,
						clientLName: formData?.lastName,
					});
				}
			} else {
				const agreementRef = firebaseRef.ref(
					'/kavtek_agreements/' +
						PROJECT_CODE.projectCode +
						`/${leadId}` +
						'/clientInfo/individual/'
				);
				agreementRef.once('value', async (snapshot) => {
					let individualObjs = snapshot.val();

					let individualObjsKeys =
						individualObjs && Object.keys(individualObjs);
					const result = individualObjsKeys?.filter(
						(key) => individualObjs[key]?.id === id
					);
					result &&
						agreementRef.child(result.toString()).update({
							identification,
						});

					if (result && isNameChanged) {
						agreementRef.child(result.toString()).update({
							firstName: formData?.firstName,
							lastName: formData?.lastName,
						});
					}
				});
			}
		});
		callback(true);
	} catch (err) {
		console.log(err);
		callback(false);
	}
}
